/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_macro_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A high-protein split raises protein to support muscle while cutting.`)
};

const es_macro_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un reparto alto en proteína la aumenta para mantener el músculo mientras se hace un déficit.`)
};

const de_macro_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine proteinreiche Verteilung erhöht das Protein, um beim Kaloriendefizit Muskeln zu erhalten.`)
};

const nl_macro_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een eiwitrijke verdeling verhoogt eiwit om spieren te behouden tijdens het afvallen.`)
};

const fr_macro_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une répartition riche en protéines augmente les protéines pour soutenir le muscle pendant une sèche.`)
};

const it_macro_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una ripartizione ricca di proteine aumenta le proteine per sostenere i muscoli durante il taglio calorico.`)
};

const pt_br2_macro_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma divisão hiperproteica aumenta a proteína para apoiar o músculo durante o corte.`)
};

const pt_macro_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma divisão rica em proteína aumenta a proteína para apoiar o músculo durante um corte.`)
};

const ja_macro_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高タンパク配分は減量中の筋肉維持のためタンパク質を増やします。`)
};

const zh_macro_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高蛋白配比会提高蛋白质摄入，有助于在减脂期间维持肌肉。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const macro_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.macro_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("macro_ex2", locale)
	if (locale === "en") return en_macro_ex2(inputs)
	if (locale === "es") return es_macro_ex2(inputs)
	if (locale === "de") return de_macro_ex2(inputs)
	if (locale === "nl") return nl_macro_ex2(inputs)
	if (locale === "fr") return fr_macro_ex2(inputs)
	if (locale === "it") return it_macro_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_macro_ex2(inputs)
	if (locale === "pt") return pt_macro_ex2(inputs)
	if (locale === "ja") return ja_macro_ex2(inputs)
	return zh_macro_ex2(inputs)
};